module.exports = "/_next/static/images/PaidSubscriptionAcquisitionDesktop-0fa0f72d7dd682b4e4020ce24419612f.png";